<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'option-cursor',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Mouse Cursor',
            tailwindDefinitionProp: 'cursor',
            value: '',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: this.titleCase(v) }));
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            let { value } = this.flexClassDefinition;

            if (!value) {
                value = this.getComputedValue();
            }

            if (this.themeObjectValues.includes(value)) {
                this.value = value;
            } else {
                this.value = '';
            }
        },
    },
};
</script>
